import {connect} from "react-redux";
import ActivityAccountCreate from "./create";
import {bindActionCreators} from "redux";
import {getActivity, saveActivity} from "../../../service/Account/action";
import {viewActivity, cancelActivity} from "../../../service/Activity/action";
import {documentUploadUrlPublic} from "../../../service/fileUpload/action";
import {getActivityById} from "../../../service/Lead/action";

const mapStateToProps = (state) => ({
    accountActivity:state.Dropdown.accountActivity,
    activityByIdDetails:state.Activity.activityByIdDetails,
    saveActivityDetails:state.Dropdown.saveActivity,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    cancelActivityDetails:state.Activity.cancelActivity,
    leadActivityById:state.Lead.leadActivityById,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getActivity,
            documentUploadUrlPublic,
            viewActivity,
            saveActivity,
            cancelActivity,
            getActivityById
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ActivityAccountCreate);
